const dummyTable = [
  {
    id: 1,
    bank_code: "ACEH SYARIAH",
    bank_desc: "PT BANK ACEH SYARIAH",
    bank_key: "VDACEHSYARIAH\r\n",
    is_active: 1,
    create_by: "ADMIN",
    create_at: "04/22/2024 10:56:03",
    update_by: "ADMIN",
    update_at: "04/22/2024 10:56:03",
  },
  {
    id: 2,
    bank_code: "BCA",
    bank_desc: "Bank Central Asia PTS",
    bank_key: "BBCA",
    is_active: 1,
    create_at: "01/01/0001 00:00:00",
    update_by: "mdf",
    update_at: "05/21/2024 03:01:38",
  },
  {
    id: 4,
    bank_code: "BBRI",
    bank_desc: "PT Bank Rakyat Indonesie",
    bank_key: "BBRI",
    is_active: 1,
    create_by: "M",
    create_at: "04/23/2024 08:03:19",
    update_at: "01/01/0001 00:00:00",
  },
  {
    id: 5,
    bank_code: "BSQU",
    bank_desc: "PT Bank SQUU",
    bank_key: "1399",
    is_active: 1,
    create_by: "string",
    create_at: "04/26/2024 06:19:49",
    update_by: "imor",
    update_at: "05/28/2024 10:43:12",
  },
  {
    id: 7,
    bank_code: "BNI",
    bank_desc: "PT BANK NASIONAL INDONESIA",
    bank_key: "BBNI",
    is_active: 1,
    create_by: "IMOR",
    create_at: "05/02/2024 02:03:24",
    update_at: "01/01/0001 00:00:00",
  },
  {
    id: 8,
    bank_code: "MEGA",
    bank_desc: "PT BANK MEGA ",
    bank_key: "MEGB",
    is_active: 1,
    create_by: "IMOR",
    create_at: "05/02/2024 02:06:51",
    update_at: "01/01/0001 00:00:00",
  },
  {
    id: 10,
    bank_code: "Permata",
    bank_desc: "PT permata indonesia",
    bank_key: "Perma/i",
    is_active: 1,
    create_by: "imor",
    create_at: "05/06/2024 03:27:05",
    update_at: "01/01/0001 00:00:00",
  },
  {
    id: 12,
    bank_code: "Capital Bank",
    bank_desc: "PT Capital Bank Indonesia",
    bank_key: "CBI/r/n",
    is_active: 1,
    create_by: "imor",
    create_at: "05/13/2024 06:34:13",
    update_at: "01/01/0001 00:00:00",
  },
  {
    id: 13,
    bank_code: "Capital",
    bank_desc: "PT Capital Bank Indonesia",
    bank_key: "CBI/r/n",
    is_active: 1,
    create_by: "imor",
    create_at: "05/13/2024 06:35:13",
    update_at: "01/01/0001 00:00:00",
  },
  {
    id: 14,
    bank_code: "CBII",
    bank_desc: "PT Capital Bank Indonesia",
    bank_key: "CBI/r/n",
    is_active: 1,
    create_by: "imor",
    create_at: "05/13/2024 06:40:23",
    update_at: "01/01/0001 00:00:00",
  },
  {
    id: 15,
    bank_code: "Ganesha",
    bank_desc: "PT Bank Ganesha Indonesia",
    bank_key: "CBI/r/n",
    is_active: 1,
    create_by: "imor",
    create_at: "05/13/2024 06:52:53",
    update_at: "01/01/0001 00:00:00",
  },
];

export default dummyTable;
